import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';

import { colorPalette, TextSizesEnum } from '../../../theme';
import { PlexTypography } from '../../shared/primitives/PlexTypography';

type Props = {
  text: string;
};
export const Heading = ({ text }: Props): React.ReactElement => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.row)}>
      <PlexTypography text={text} size={TextSizesEnum.Large} className={classes.heading} />
    </div>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      paddingLeft: 48,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      borderBottom: `1px solid ${colorPalette.gray._300}`,
    },
    heading: {
      paddingTop: 24,
      paddingBottom: 24,
      fontWeight: 600,
      color: colorPalette.general.text2,
    },
  })
);
